import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { Warning } from '@mui/icons-material';

/**
 * Delete confirmation dialog
 */
const DeleteConfirmDialog = ({ 
  open, 
  file, 
  onConfirm, 
  onCancel, 
  hasPermission = true 
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Warning sx={{ color: 'text.secondary' }} />
          Confirm Delete
        </Box>
      </DialogTitle>
      <DialogContent>
        {hasPermission ? (
          <Typography variant="body1" gutterBottom>
            Are you sure you want to delete <strong>{file?.name}</strong>?
          </Typography>
        ) : (
          <Typography color="error" variant="body1">
            You do not have permission to delete this file.
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
